import site from '@src/state/site/site'
import siteConfig from '@src/state/site/siteConfig'
import { LOCAL_OR_PLAYGROUND } from '../localOrPlayground'
import { createAxiosInstance, responseInterceptor } from './baseAxiosInstance'
import { errorInterceptor } from './wbeDataApi'

const wtaiBaseUrl =
  process.env.REACT_APP_WTAI_API_URL || siteConfig(site, LOCAL_OR_PLAYGROUND).wtaiUrl

const wtaiApi = createAxiosInstance(wtaiBaseUrl)

wtaiApi.interceptors.response.use(responseInterceptor, errorInterceptor(wtaiApi))

export default wtaiApi



// WEBPACK FOOTER //
// ./src/utils/http-clients/wtaiApi.ts